module.exports = __webpack_public_path__ + "static/logo-55509d5f4e755c849dc6d3bf3e0237b6.svg";